
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M9.99998 8.49998V15.5C9.99998 15.91 10.47 16.15 10.8 15.9L15.47 12.4C15.74 12.2 15.74 11.8 15.47 11.6L10.8 8.09998C10.47 7.84998 9.99998 8.08998 9.99998 8.49998ZM11 3.22998C11 2.58998 10.41 2.09998 9.78998 2.23998C8.66998 2.49998 7.60998 2.93998 6.66998 3.53998C6.13998 3.87998 6.05998 4.63998 6.50998 5.08998C6.82998 5.40998 7.33998 5.48998 7.71998 5.24998C8.48998 4.75998 9.33998 4.39998 10.26 4.19998C10.7 4.09998 11 3.68998 11 3.22998ZM5.09998 6.50998C4.63998 6.05998 3.88998 6.12998 3.54998 6.66998C2.94998 7.60998 2.50998 8.66998 2.24998 9.78998C2.10998 10.41 2.58998 11 3.22998 11C3.67998 11 4.09998 10.7 4.18998 10.26C4.38998 9.34998 4.75998 8.48998 5.23998 7.72998C5.49998 7.33998 5.41998 6.82998 5.09998 6.50998ZM3.22998 13C2.58998 13 2.09998 13.59 2.23998 14.21C2.49998 15.33 2.93998 16.38 3.53998 17.33C3.87998 17.87 4.63998 17.94 5.08998 17.49C5.40998 17.17 5.48998 16.66 5.23998 16.28C4.74998 15.52 4.38998 14.67 4.18998 13.75C4.09998 13.3 3.68998 13 3.22998 13ZM6.66998 20.45C7.61998 21.05 8.66998 21.49 9.78998 21.75C10.41 21.89 11 21.4 11 20.77C11 20.32 10.7 19.9 10.26 19.81C9.34998 19.61 8.48998 19.24 7.72998 18.76C7.33998 18.52 6.83998 18.59 6.51998 18.92C6.05998 19.36 6.12998 20.11 6.66998 20.45ZM22 12C22 16.73 18.7 20.71 14.27 21.74C13.65 21.89 13.05 21.4 13.05 20.76C13.05 20.3 13.36 19.9 13.8 19.79C17.35 18.97 20 15.79 20 12C20 8.20998 17.35 5.02998 13.8 4.20998C13.36 4.10998 13.05 3.69998 13.05 3.23998C13.05 2.59998 13.65 2.10998 14.27 2.25998C18.7 3.28998 22 7.26998 22 12Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-slow-motion-video`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSlowMotionVideo

    ```js
    <b-new-b-icon-slow-motion-video />
    ```
</docs>


